export class PrinterTypes {
    static readonly Etiquetas = "printer-etiquetas";
    static readonly Guias = "printer-guias";
    static readonly Predeterminada = "printer-predeterminada";
}

export class PrinterTypesText {
    static readonly Labels = "Etiquetas";
    static readonly Guias = "Guías";
    static readonly Predeterminada = "Predeterminada";
}